import { TabPanel } from "@website/accommodation-ui/villa-reserve-cancellation-policies/components/tab-panel-cancellation-type/tab-panel";
import {
  VillaCancellationRulesType,
  villaReserveCancellationPolicyType
} from "@website/accommodation-ui/villa-reserve-cancellation-policies/index.types";
import { useEffect, useMemo, useState } from "react";

export const useVillaReserveCancellationPolicies = (
  properties: villaReserveCancellationPolicyType
) => {
  const { policies, cancellationPlanType } = properties;
  const [isRulesModalOpen, setIsRulesModalOpen] = useState(false);
  const [filteredPolicies, setFilteredPolicies] = useState<
    Array<VillaCancellationRulesType>
  >([]);

  useEffect(() => {
    setFilteredPolicies(policies.filter((p) => Boolean(p.text)));
  }, [policies]);

  const policiesData = useMemo(() => {
    const tabs = filteredPolicies.map((p) => ({
      title: p.title as string,
      panel: (
        <TabPanel
          cancellationPlanType={cancellationPlanType}
          cancellationRules={p.text}
        />
      )
    }));

    return {
      tabs
    };
  }, [filteredPolicies, cancellationPlanType]);

  const openRulesModal = () => {
    setIsRulesModalOpen(true);
  };
  const closeRulesModal = () => {
    setIsRulesModalOpen(false);
  };

  return {
    isRulesModalOpen,
    openRulesModal,
    closeRulesModal,
    policiesData,
    defaultTabPanel: policiesData?.tabs?.[0]?.panel
  };
};
